import { AbstractPageTemplate } from '../AbstractPageTemplate/AbstractPageTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListingPage = props => {
  return /*#__PURE__*/_jsx(AbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true
  }));
};